'use client';
import { useEffect } from 'react';
import { useNextHydratedStore } from './useNextHydratedStore';

/**
 * A hook to records and returns the state of Next JS hydration
 */

export const useNextHydrated = () => {
  const { value, setValue } = useNextHydratedStore();

  useEffect(() => {
    setValue(true);
    return () => setValue(false);
  }, [setValue]);
  return value;
};
